import home from './menu/home.svg';
import products from './menu/products.svg';
import sales from './menu/sales.svg';
import buyer from './menu/buyer.svg';
import home_filled from './menu/home_filled.svg';
import products_filled from './menu/products_filled.svg';
import sales_filled from './menu/sales_filled.svg';
import buyer_filled from './menu/buyer_filled.svg';
import logo from './logo.svg';
import mail_setting from './mail_setting.svg';
import email from './icons/email.svg';
import left_arrow from './icons/left_arrow.svg';
import eye from './icons/eye.svg';
import heart from './icons/heart.svg';
import eye_visible from './icons/eye_visible.svg';
import trash from './icons/trash.svg';
import add from './icons/add.svg';
import error from './icons/error.svg';
import avatar from './icons/avatar.svg';
import empty_buyer_list from './empty_buyer_list.svg';
import empty_address_list from './empty_address_list.svg';
import empty_similar_product_list from './empty_similar_product_list.svg';
import no_products from './icons/no_products.svg';
import no_preview from './no_preview.svg';
import no_data from './no_data.svg';
import file from './icons/file.svg';
import done from './icons/done.svg';
import warning from './icons/warning.svg';
import add_import from './import_data/add.png';
import add_and_update_import from './import_data/add_and_update.png';
import update_import from './import_data/update.png';
import unseen_notification from './icons/unseen_notification.svg';
import no_search_results from './NoSearchResults.svg';
import icon_import_export from './icons/icon_import_export.svg';
import icon_import_export_disabled from './icons/icon_import_export_disabled.svg';
import NoTableResult from 'src/assets/images/NoTableResult.png';
import EmptyBuyerDashboardImage from 'src/assets/images/EmptyBuyerDashboardImage.png';
import ProductNotFound from 'src/assets/images/ProductNotFound.png';
import active_step from 'src/assets/images/icons/active_step.svg';
import info from 'src/assets/images/icons/info.svg';
import inactive_step from 'src/assets/images/icons/step.svg';
import shopify_icon from 'src/assets/images/shopifyIcon.png';
import cart_icon from 'src/assets/images/icons/cart_icon.svg';
import error_500 from 'src/assets/images/error_500.png';
import custom_filter_icon from './custom_filter_icon.svg';
import custom_active_filter_icon from './custom_active_filter_icon.svg';
import SourceWizLogo from './SourceWizLogo.png';
import ErrorLogo from './ErrorLogo.png';
import payment_pending from './payment_pending.svg';
import payment_failed from './payment_failed.gif';
import payment_successful from './payment_successful.gif';
import DiscountIconChecked from '../images/icons/DiscountIconChecked.svg';
import LogoNoText from './logo_icon.png';
import LogoWithText from './LogoWithText.png';
import SparkleLogo from './SparkleLogo.svg';
import disconnect from './disconnect.png';
import connected from './connected.png';
import send_mail from './send_mail.png';
import Terminal from '../images/Terminal.png';
import terminal_icon from '../images/terminal_icon.png';
import advance_payment from '../images/advance_payment.png';
import no_preview_options from './no_preview_options.svg';
import zoho_logo from '../images/zoho.png';
import sos_inventory_logo from '../images/sos_inventory.png';
import sync_now from './sync_now.gif';
import not_found_404 from './404NotFound.png';
import intercom_icon from './intercom_icon.svg';
import empty_catalog from './Empty_catalog.svg';
import insights from './insight.svg';
import insight_white from './insightwhite.svg';
import unchecked from './unchecked.svg';
import checked from './checked.svg';
import intermediate from './intermediate.svg';
import empty_wishlist from './no-wishlist.svg';
import SmartSearchIcon from './SmartSearchIcon.svg';
import SmartSearchIcon2 from './SmartSearchIcon2.svg';
import SmartSearchIcon3 from './SmartSearchIcon3.svg';
import PhotoScanImage from './PhotoScanImage.svg';
import AbandonedCart from './adandoned_card.png';
import CalendarClock from './icons/calendar-clock.svg';
import ProductDiscount from './product_discount.png';
import CartDiscount from './cart_discount.png';
import wizAvatar from './wizAvatar.svg';
import QuickBook from './quick_book.png';
import FloatCart from './icons/cart_float.svg';
import WizAiGraph from './WizAiGraph.png';
import InsightIconSvg from './InsightIconSvg.svg';
import ask_kai from './ask_kai.svg';
import ask_kai2 from './ask_kai2.svg';
import kai from './kai.svg';
import emptyScreenAnimation from './emptyScreenAnimation.svg';
import fallback from './fallback.png';
import stars from './stars.svg';
import starsGrey from './starsGrey.svg';
import blank_image from './blank_image.png';
import startsPurpleFilled from './startsPurpleFilled.svg';
import startsGreyFilled from './startsGreyFilled.svg';
import SendRight from './send_right_icon.svg';
import IconCircleLarge from './IconCircleLarge.svg';
import uploaded_img from './uploaded_img.svg';
import AiSearchImageUpload from './AiSearchImageUpload.svg';
import AiSearchImageUploadLight from './AiSearchImageUploadLight.svg';
import SearchInProductImages from './SearchInProductImages.svg';
import CustomerSegment from './customer_segment.svg';
import ProductSegment from './product_segment.svg';
import CustomerSegmentWhite from './customer_segment_white.svg';
import ProductSegmentWhite from './product_segment_white.svg';
import starsWhite from './starsWhite.svg';
import kaiFull from './kaiFull.svg';
import PriceListIcon from './icons/coins.svg';
import PrimaryCart from './icons/primary_cart.svg';
import CollectionNotFound from './collection_not_found.png';
import CategoryNotFound from './category_not_found.png';
import notes_empty_message from './notes_empty_message.svg';
import task_empty_message from './task_empty_message.svg';
import activity_empty_message from './activity_empty_message.svg';
import EditCardFallback from './fallbackLabel.svg';
import HistoryIcon from './history_icon.svg';
import HistoryIconDark from './history_icon_white_bg.svg';
import map_pin_check from './map_pin_check.svg';
import NoInsightsFound from './no_insights_found.svg';
import WizStudioSSO from './WizStudioSSO.svg';
import empty_visits from './empty_visits.svg';
import no_image_placeholder from './no_image.svg';
import VectorAI from './VectorAI.svg';
import NoWidget from './nowidget.svg';
import NoUploadedImagePIM from './no_upload_image.svg';
import EmptyClassifications from './empty_classification.svg';
import BetaVersion from './beta_version.png';
import EmptyKanban from './empty_kanban.svg';
import IconPay from './icons/pay.svg';
import FileIcon from './file.svg';
import PowerPointIcon from './powerpoint.svg';
import WordIcon from './word.svg';
import ZipIcon from './zip.svg';
import GalleryIcon from './gallery.svg';
import ExcelIcon from './excel_file.svg';
import no_sync_history from './no_sync_history.svg';
import ai_suggested from './ai_suggested.svg';
import pdf_extracted from './pdf_extracted.svg';
import select_contact_address from './select_contact_address.svg';
import adhoc_item from './adhoc_item.svg';
import empty_contact from './empty_contact.svg';
import empty_address from './empty_address.svg';
import no_orders from './no-orders.svg';
import resize_icon from './resize_icon.png';
import settings from './settings.svg';
import system_default from './system_default.svg';
import not_tracking_inventory from './not_tracking_inventory.svg';
import excel from 'src/assets/images/excel_file.svg';
import csv from 'src/assets/images/csv.png';
import docx from 'src/assets/images/docx.png';
import image from 'src/assets/images/image.png';
import sparkles from 'src/assets/images/sparkles.svg';
import ella_ai from 'src/assets/images/ella_ai.svg';
import ai_logo from 'src/assets/images/ai_logo.png';
import LoginLogo from './LoginLogo.svg';
import ella_admin_banner from './ella_banner.png';

const empty_comment = 'https://frontend-bucket.vercel.app/images/empty_comment.svg';
const generative_image = 'https://frontend-bucket.vercel.app/images/generative_image.svg';
const logged_out = 'https://frontend-bucket.vercel.app/images/storefront/logged-out.svg';

const ImageLinks = {
	home,
	logo,
	products,
	sales,
	buyer,
	home_filled,
	products_filled,
	sales_filled,
	buyer_filled,
	email,
	left_arrow,
	eye,
	eye_visible,
	trash,
	add,
	heart,
	error,
	avatar,
	EmptyClassifications,
	active_step,
	info,
	BetaVersion,
	inactive_step,
	empty_buyer_list,
	empty_similar_product_list,
	no_products,
	DiscountIconChecked,
	no_preview,
	no_data,
	file,
	done,
	warning,
	add_import,
	add_and_update_import,
	update_import,
	no_image_placeholder,
	unseen_notification,
	no_search_results,
	icon_import_export,
	icon_import_export_disabled,
	NoTableResult,
	EmptyBuyerDashboardImage,
	ProductNotFound,
	shopify_icon,
	cart_icon,
	error_500,
	custom_filter_icon,
	custom_active_filter_icon,
	SourceWizLogo,
	ErrorLogo,
	LogoNoText,
	LogoWithText,
	SparkleLogo,
	mail_setting,
	disconnect,
	connected,
	send_mail,
	payment_pending,
	payment_failed,
	payment_successful,
	Terminal,
	terminal_icon,
	zoho_logo,
	advance_payment,
	no_preview_options,
	sos_inventory_logo,
	sync_now,
	not_found_404,
	intercom_icon,
	empty_catalog,
	insights,
	insight_white,
	checkbox_unchecked: unchecked,
	checkbox_checked: checked,
	checkbox_intermediate: intermediate,
	empty_wishlist,
	SmartSearchIcon,
	SmartSearchIcon2,
	SmartSearchIcon3,
	PhotoScanImage,
	AbandonedCart,
	CalendarClock,
	ProductDiscount,
	QuickBook,
	FloatCart,
	CartDiscount,
	wizAvatar,
	WizAiGraph,
	InsightIconSvg,
	ask_kai,
	ask_kai2,
	kai,
	emptyScreenAnimation,
	blank_image,
	fallback,
	stars,
	starsGrey,
	LoginLogo,
	startsPurpleFilled,
	startsGreyFilled,
	SendRight,
	IconCircleLarge,
	uploaded_img,
	NoUploadedImagePIM,
	AiSearchImageUpload,
	AiSearchImageUploadLight,
	SearchInProductImages,
	CustomerSegment,
	CustomerSegmentWhite,
	ProductSegment,
	ProductSegmentWhite,
	starsWhite,
	kaiFull,
	logged_out,
	PriceListIcon,
	PrimaryCart,
	CollectionNotFound,
	CategoryNotFound,
	notes_empty_message,
	activity_empty_message,
	task_empty_message,
	EditCardFallback,
	HistoryIcon,
	HistoryIconDark,
	map_pin_check,
	NoInsightsFound,
	WizStudioSSO,
	empty_visits,
	empty_address_list,
	VectorAI,
	NoWidget,
	EmptyKanban,
	IconPay,
	FileIcon,
	PowerPointIcon,
	ZipIcon,
	WordIcon,
	GalleryIcon,
	ExcelIcon,
	no_sync_history,
	not_tracking_inventory,
	generative_image,
	empty_comment,
	ai_suggested,
	pdf_extracted,
	select_contact_address,
	adhoc_item,
	empty_contact,
	empty_address,
	no_orders,
	resize_icon,
	settings,
	system_default,
	excel,
	csv,
	docx,
	image,
	sparkles,
	ella_ai,
	ai_logo,
	ella_admin_banner,
};

export default ImageLinks;
